import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate
} from 'react-router-dom';

import Sidebar from './components/layout/Sidebar';
import Topbar from './components/layout/Topbar';
import Login from './Login';
import Radnici from './components/Radnici';
import Vozila from './components/Vozila';
import Dnevnice from './components/Dnevnice';
import Plate from './components/Plate';
import Download from './components/Download';
import Korisnici from './components/Korisnici';
import Settings from './components/Settings';
import SefUpload from './components/SefUpload';
import KalkulatorKucista from './components/KalkulatorKucista';
import LEDEkrani from './components/LEDEkrani';
import MobilniLEDEkrani from './components/MobilniLEDEkrani';

function MobileRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => window.innerWidth <= 768;

    const allowedMobilePaths = [
      '/led-ekrani',
      '/mobileledscreen'
    ];

    if (
      checkMobile() &&
      !allowedMobilePaths.includes(location.pathname)
    ) {
      navigate('/led-ekrani', { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}

function AppContent({ user, handleLogout }) {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 768
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100dvh',
        minHeight: '100vh',
        backgroundColor: '#050a1a',
        overflow: 'hidden'
      }}
    >
      {!isMobile && (
        <Topbar
          user={user}
          onLogout={handleLogout}
        />
      )}

      <div
        style={{
          display: 'flex',
          flex: 1,
          minHeight: 0,
          overflow: 'hidden'
        }}
      >
        {!isMobile && (
          <Sidebar onLogout={handleLogout} />
        )}

        <main
          style={{
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            overflowY: 'auto',
            padding: isMobile ? '0' : '20px',
            WebkitOverflowScrolling: 'touch'
          }}
        >
          <Routes>
            <Route
              path="/led-ekrani"
              element={<LEDEkrani />}
            />

            <Route
              path="/mobileledscreen"
              element={<MobilniLEDEkrani />}
            />

            {!isMobile && (
              <>
                <Route
                  path="/plate"
                  element={<Plate />}
                />

                <Route
                  path="/dnevnice"
                  element={<Dnevnice />}
                />

                <Route
                  path="/sef-upload"
                  element={<SefUpload />}
                />

                <Route
                  path="/kalkulator"
                  element={<KalkulatorKucista />}
                />

                <Route
                  path="/radnici"
                  element={<Radnici />}
                />

                <Route
                  path="/vozila"
                  element={<Vozila />}
                />

                <Route
                  path="/korisnici"
                  element={<Korisnici />}
                />

                <Route
                  path="/download"
                  element={<Download />}
                />

                <Route
                  path="/settings"
                  element={<Settings />}
                />
              </>
            )}

            <Route
              path="/"
              element={
                <Navigate
                  to={
                    isMobile
                      ? '/mobileledscreen'
                      : '/dnevnice'
                  }
                  replace
                />
              }
            />

            <Route
              path="/login"
              element={
                <Navigate
                  to={
                    isMobile
                      ? '/mobileledscreen'
                      : '/dnevnice'
                  }
                  replace
                />
              }
            />

            <Route
              path="*"
              element={
                <Navigate
                  to={
                    isMobile
                      ? '/mobileledscreen'
                      : '/dnevnice'
                  }
                  replace
                />
              }
            />
          </Routes>
        </main>
      </div>

      <MobileRedirect />
    </div>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [checkingSession, setCheckingSession] = useState(true);

  useEffect(() => {
    let active = true;

    fetch('/core/get-current-user/', {
      credentials: 'include'
    })
      .then(async (response) => (
        response.ok ? response.json() : null
      ))
      .then((data) => {
        if (!active) return;

        if (data?.authenticated && data?.username) {
          setUser(data.username);
          localStorage.setItem('user', data.username);
        } else {
          setUser(null);
          localStorage.removeItem('user');
        }
      })
      .catch(() => {
        if (active) {
          setUser(null);
          localStorage.removeItem('user');
        }
      })
      .finally(() => {
        if (active) {
          setCheckingSession(false);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  const handleLogin = (username) => {
    localStorage.setItem('user', username);
    setUser(username);
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
  };

  if (checkingSession) {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#050a1a',
          color: 'white'
        }}
      >
        Provera prijave...
      </div>
    );
  }

  return (
    <Router>
      {!user ? (
        <Routes>
          <Route
            path="/login"
            element={
              <Login onLogin={handleLogin} />
            }
          />

          <Route
            path="*"
            element={
              <Navigate to="/login" replace />
            }
          />
        </Routes>
      ) : (
        <AppContent
          user={user}
          handleLogout={handleLogout}
        />
      )}
    </Router>
  );
}

export default App;